<template>
  <div class="login-page">
    <div>
      <div class="form">
        <div class="form__image">
          <img class="logo" src="../../../assets/images/hrdesk-logo-dark-beta.png" />
        </div>
        <div class="form__text">Let's Get You Started</div>
        <form>
          <div class="login-form">
            <div class="login-form--email">Enter your Email Address:</div>
            <div class="login-form--link"></div>
            <div class="login-form--input">
              <input type="text" placeholder="Enter your email address" v-model="email" />
            </div>
          </div>

          <div class="login-form">
            <div class="login-form--email">Enter your Phone Number:</div>
            <div class="login-form--link"></div>
            <div class="login-form--input">
              <input type="text" placeholder="Enter your phone number" v-model="phone" />
            </div>
          </div>

          <div class="login-form">
            <div class="login-form--password">Enter your Password</div>

            <div class="login-form--input">
              <input type="password" placeholder="Enter your password" v-model="password" />
            </div>
          </div>

          <div class="login-error">
            <p v-show="emailError">Please enter your email address.</p>
            <p v-show="phoneError">Please enter your phone number.</p>
            <p v-show="passwordError">Please enter password.</p>
            <p v-show="passwordLengthError">Password must be 8 or more characters.</p>
            <p v-show="networkError">We experienced a network error. Please try again.</p>
            <p v-if="dataSaveError">{{ dataSaveError }}</p>
            <div v-if="serverErrors">
              <p v-for="(value, name, index) in serverErrors" :key="index">{{ value[0] }}</p>
            </div>
          </div>

          <div class="login-btn">
            <button @click.prevent="login" v-show="!load">Sign up</button>
            <div v-show="load">
              <WhiteLoader />
            </div>
          </div>

          <div class="login-signup">
            Already registered?
            <routerLink to="/login">Login to your account</routerLink>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import * as types from "../../../store/constant";
import WhiteLoader from "../../partials/white-loader";

export default {
  name: "JobseekerSignup",
  components: {
    WhiteLoader
  },
  data() {
    return {
      load: false,
      networkError: false,
      credentialsError: false,
      emailError: false,
      phoneError: false,
      passwordError: false,
      passwordLengthError: false,
      email: "",
      phone: "",
      password: "",
      serverErrors: null,
      dataSaveError: ""
    };
  },
  methods: {
    login() {
      this.emailError = false;
      this.phoneError = false;
      this.passwordError = false;
      this.passwordLengthError = false;
      this.networkError = false;
      this.credentialsError = false;

      const expression = /\S+@\S+\.\S+/;
      if (this.email.trim() === "") {
        this.emailError = true;
        return;
      }

      if (!expression.test(this.email.trim())) {
        this.emailError = true;
        return;
      }

      if (isNaN(this.phone.trim())) {
        this.phoneError = true;
        return;
      }

      if (this.phone.trim() === "") {
        this.phoneError = true;
        return;
      }

      if (this.password.trim() === "") {
        this.passwordError = true;
        return;
      }

      if (this.password.trim().length < 8) {
        this.passwordLengthError = true;
        return;
      }

      this.load = true;

      const signupData = {
        email: this.email,
        phone: this.phone,
        password: this.password
      };

      this.$store
        .dispatch(types.JOBSEEKER_AUTH_REGISTER, signupData)
        .then(resp => {
          this.$router.push("/login");
        })
        .catch(err => {
          this.load = false;
          if (err.response) {
            const message = err.response.data.message;
            if (typeof message === "object") {
              this.serverErrors = message;
            } else {
              this.dataSaveError = message;
            }
          }
        });
    }
  }
};
</script>

<style lang="css" scoped>
.login-page {
  background: #fbfafa;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
}

.remember-me {
  display: block;
  width: 50px;
  float: left;
}

.icon-space {
  margin: 1px;
}

.login-page>div {
  max-width: 600px;
  margin: 50px auto;
  padding: 0 10px;
}

.form {
  border-radius: 2px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  text-align: center;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 7.552vw;
  padding-right: 7.552vw;
}

.form__image {
  margin: auto;
  max-width: 183px;
}

.form__text {
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  text-align: center;
  color: #f79320;
  margin: 20px 0;
}

.login-form {
  margin-top: 20px;
  overflow: hidden;
}

.login-form--email {
  width: 100%;
  float: left;
  text-align: left;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 2;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
}

.login-form--password {
  width: 55%;
  float: left;
  text-align: left;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 2;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
}

.login-form--link {
  width: 45%;
  float: left;
  text-align: right;
  font-size: 13px;
  font-weight: 200;
  font-style: normal;
  font-stretch: normal;
  line-height: 2.22;
  letter-spacing: normal;
  text-align: right;
}

.login-form--link>a {
  text-decoration: none;
  color: #5099de;
}

.login-form--input {
  max-width: 523px;
  margin: auto;
  height: 40px;
  border: solid 1px #c7c7c7;
  clear: both;
  overflow: hidden;
}

.login-form--input>input {
  height: 40px;
  border: none;
  outline: none;
  padding: 0 5px;
  font-size: 13px;
  font-weight: 200;
  font-style: normal;
  font-stretch: normal;
  line-height: 2.5;
  letter-spacing: normal;
  text-align: left;
  color: #000;
}

.login-form--input>input::placeholder {
  background: transparent;
  opacity: 0.32;
}

.login-form--input>input::-ms-input-placeholder {
  background: transparent;
  opacity: 0.32;
}

.login-form--input>input::-ms-input-placeholder {
  background: transparent;
  opacity: 0.32;
}

.login-error {
  /* height: 20px; */
  margin-top: 10px;
  color: red;
  font-size: 12px;
  font-style: italic;
}

.login-error>p {
  margin: 0;
  color: red;
}

.login-btn {
  margin-top: 10px;
  margin-bottom: 26px;
}

.login-btn>button {
  border-radius: 2px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  background-color: #5099de;
  height: 40px;
  border: none;
  outline: none;
  color: #fff;
  font-size: 13px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.22;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
}

.login-btn>div {
  border-radius: 2px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  background-color: #5099de;
  height: 40px;
  border: none;
  outline: none;
  color: #fff;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.22;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  align-content: center;
}

.login-signup {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.63;
  letter-spacing: normal;
  text-align: center;
  color: #000000;
}

.login-signup>a {
  text-decoration: none;
  color: #5099de;
}

.login-checkbox {
  text-align: left;
  overflow: hidden;
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-start;
  align-content: flex-start;
}

.login-checkbox-box {
  width: 20px;
  height: 20px;
  float: left;
  text-align: left;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-start;
  align-content: center;
}

.login-checkbox-text {
  width: 300px;
  height: 20px;
  float: left;
  font-size: 14px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  text-align: left;
  color: #000000;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-start;
  align-content: center;
}

.line-through {
  margin-top: 20px;
  width: 100%;
  text-align: center;
  border-bottom: 1px solid #c7c7c7;
  line-height: 0.1em;
  margin: 10px 0 20px;
  color: grey;
}

.line-through span {
  background: #fff;
  padding: 0 10px;
  color: #c7c7c7;
}

.form__google {
  height: 40px;
  border-radius: 2px;
  margin-top: 26px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  align-content: center;
  border: solid 1px #c7c7c7;
  cursor: pointer;
}

.form__google>div {
  width: 95px;
  margin: auto;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  align-content: center;
}

.form__google--image {
  width: 28px;
  float: left;
}

.form__google--name {
  float: right;
  padding-top: 0.26vw;
  width: 60px;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.22;
  letter-spacing: normal;
  text-align: center;
  color: #5099de;
}

.message {
  font-size: 12px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.31;
  letter-spacing: normal;
  text-align: center;
  color: #5099de;
  padding-bottom: 5px;
}

.message>a {
  color: #bababc;
}

.footer-message {
  text-align: center;
  margin-top: 29px;
}

.footer-message--register {
  font-size: 12px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.31;
  letter-spacing: normal;
  text-align: center;
  color: #777777;
}

.footer-message--register>a {
  color: #5099de;
  text-decoration: none;
}

.footer-message--company {
  font-size: 12px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.31;
  letter-spacing: normal;
  text-align: center;
  color: #5099de;
}

.footer-message--company>a {
  color: #5099de;
  text-decoration: none;
}

.footer-message--copyright {
  font-size: 12px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.31;
  letter-spacing: normal;
  text-align: center;
  color: #000000;
}
</style>
